import React, { Component, Fragment } from 'react';
import { Arc, Circle, Text, TextPath, Image} from 'react-konva';
import {
  fontFamily,
  isDevelopment,
  isSeinfeld,
  // imageBasePath,
  fullNameFontStyle,
  fullNameLineHeight,
  minScreenWidthFanchart,
  translatedLabels,
  isRtl,
  // maleDefaultColor,
  // femaleDefaultColor
} from '../../library/constants';
import {
  buildDateAliveText,
  getImgURLdataFromSVG,
  // changeFillColor,
  getWidthKonvaText,
  // centerXFanchart,
  // centerYFanchart,
  urlGet,
  toUpper,
  shrinkWordsWidth,
  isMobilePhone,
  isMobileTablet,
} from '../../library/calc';

/*

http://192.168.0.54:5000/family-tree/poster/99200?ahn=true&export=true&isFanChart=true

 */

class FanChart extends Component {

  ahnOnly = urlGet('ahn') === "true" ? true: false;
  testAhn = (parseInt(urlGet('testAhn'),10) === 0 || !isDevelopment ? undefined: parseInt(urlGet('testAhn'),10)) ;
  // ahnOnly = isDevelopment ? true: false;
  // ahnOnly = true;

  count = 0;
  // screenHasWidth = 890;
  fontSize = 12;
  halfCircle = 180;
  ringSize = .25;
  margin = 150;
  arcThickness = minScreenWidthFanchart/15.05;
  state = {
    highlightFocus: false,
    highlightGhost: 0,
    highlight: 0,
    highlightFrozen: 0,
    highlightOtherAhn: 0,
    dragOverHighlight: 0,
    floaterActive: false,
    isPrint: false
  };

  launchAddNodeTriTipPopModalObj = {}

  constructor(props){
    super(props);

    // console.log(`this.props.maxAncestorGen: `, this.props.maxAncestorGen);
    // console.log(`this.props.ancestors: `, this.props.ancestors);
    // console.log(`this.props.fanchartObj.levels: `, this.props.fanchartObj.levels);


    this.maxLevels = this.props.fanchartObj.levels ? this.props.fanchartObj.levels: this.props.ancestors;

    this.maxLevels = (this.props.maxAncestorGen < this.props.ancestors ? this.props.maxAncestorGen: this.props.ancestors)

    if( isDevelopment ) this.maxLevels = parseInt(urlGet('levels'),10);
    if( this.maxLevels < 4 ) this.maxLevels = 4;
    this.maxLevels++;
    if( this.maxLevels > 8 ) this.maxLevels = 8;
    this.createHashObjs({levels: this.maxLevels});
    if(isDevelopment  || isSeinfeld) document.getElementById("debugDiv0").innerHTML = `levels: ${this.maxLevels}`;
    // this.centerX = centerXFanchart();
    // this.centerY = centerYFanchart();

    this.centerX = 700
    this.centerY = 545

    const maxLength = 19;
    this.addFatherStr = shrinkWordsWidth({word: toUpper(translatedLabels['Add father'].translatedLabel), maxLength})
    this.addMotherStr = shrinkWordsWidth({word: toUpper(translatedLabels['Add mother'].translatedLabel), maxLength});


/*

    const n = 8681;
    const ahnNumber = this.findAhnByNode(n, this.props.fanChartData);

       console.log(`%c ahnNumber : ${ ahnNumber }`, [
         'color: white',
         'background: orange',
         'font-size: 14px',
         'border: 5px solid red',
         'padding: 10px',
         ].join(';'));
 */

      //console.log(`this.props.nodeObjs[n]: `, JSON.stringify(this.props.nodeObjs[n].cidsArr, null, 2));

      //console.log(`this.props.fanChartData: `, JSON.stringify(this.props.fanChartData, null, 2));

    // const getOtherValue = (arr, val)=> {
    //   if (arr.length !== 2) {
    //     throw new Error("Array must have exactly two elements");
    //   }
    //   return arr.find(x => x !== val);
    // }

    // const arr = this.props.nodeObjs[n].cidsArr;

      // console.log(getOtherValue(arr, n)); // Output: 8679

    // console.log(`this.props.fanChartData: `, JSON.stringify(this.props.fanChartData, null, 2));

  }

  componentDidUpdate(){
    // this.centerX = this.state.isPrint ? 700: centerXFanchart();
    // this.centerY = this.state.isPrint ? 545: centerYFanchart();
  }

  shouldUpdate = true;
  shouldComponentUpdate(nextProps, nextState) {
    return this.shouldUpdate;
  }

  allowComponentUpdate(bool){

    if(typeof(bool) === 'undefined' ){
      this.shouldUpdate = ( this.shouldUpdate === false ? true: false)
    } else {
      this.shouldUpdate = bool;
    }
  }

  highlightOtherCid({node}){

    if(typeof(node) === 'undefined') return;

    const getOtherValue = (arr, val)=> {
      if (arr.length !== 2) {
        throw new Error("Array must have exactly two elements");
      }
      return arr.find(x => x !== val);
    }
    let otherCidNode
    this.props.cidsGrps.forEach((cids)=>{
      if(cids.includes(node)){
        otherCidNode = getOtherValue(cids, node);
      }
    });

    if(typeof(otherCidNode) === 'undefined' ){
      this.setHighlightOther(0)
      return;
    }

    const otherAhn = this.findAhnByNode(otherCidNode, this.props.fanChartData);

    if( otherAhn ) this.setHighlightOther(otherAhn);

  }

  findAhnByPrId(pr_id, data){

    function search(node) {
      if (node.node.pr_id === pr_id) {
          return node.node.ahn;
      }
      if (node.parents) {
          for (let parent of node.parents) {
              let result = search(parent);
              if (result !== null) {
                  return result;
              }
          }
      }
      return null;
    }

    return search(data);
  }

  findAhnByNode(n, data){

    function search(data) {
      if (data && data.node.n === n) {
          return data.node.ahn;
      }
      if (data && data.parents) {
          for (let parent of data.parents) {
              let result = search(parent);
              if (result !== null) {
                  return result;
              }
          }
      }
      return null;
    }

    return search(data);
  }

  isPrint(isPrint){
    this.setState({
      highlightFocus: false,
      highlight: 0,
      highlightOtherAhn: 0,
      highlightFrozen: 0,
      highlightGhost: 0,
      dragOverHighlight: 0,
      isPrint: isPrint
    })
  }

// this.fanChartComponent.current.highlightFromSidePanel({prId})

  highlightFromSidePanel({prId}){

    this.setHighlightGhost(0);
    this.setHighlight(0); this.setDragOverHighlight(0);
    this.setHighlightFrozen(0);
    this.setHighlightFocus({how:false});
    const ahnNumber = this.findAhnByPrId(prId, this.props.fanChartData);
    // console.log(`ahnNumber: `, ahnNumber);
    if(ahnNumber === 1) this.setHighlightFocus({how:true});
    else this.setHighlightFrozen(ahnNumber)
  }

  setFloaterActive(bool){
    this.setState({
      floaterActive: bool
    })
    if( !bool ) this.setDragOverHighlight(0);
  }

  launchFloaterMoveDecisionPanel(){

    console.log(`this.state.dragOverHighlight: `, this.state.dragOverHighlight);

    if( this.state.dragOverHighlight === 0 ){
      return false;
    }

    console.log(`%c launchFloaterMoveDecisionPanel`, [
    'color: white',
    'background: orange',
    'font-size: 14px',
    'border: 5px solid red',
    'padding: 10px',
    ].join(';'));


    console.log(`%c dragOverHighlight : ${ this.state.dragOverHighlight }`, [
      'color: white',
      'background: orange',
      'font-size: 14px',
      'border: 5px solid red',
      'padding: 10px',
      ].join(';'));

    console.log(`name: `, JSON.stringify(this.floaterAhnObj.parentNode.node.nm, null, 2));
    console.log(`prId: `, JSON.stringify(this.floaterAhnObj.parentNode.node.pr_id, null, 2));

    let {x,y, rotation } = this.getXYaddNodePanelCoor(this.floaterAhnObj);

    console.log(`{x,y, rotation }: `, JSON.stringify({x,y, rotation }, null, 2));

    this.props.setMoveDecisionPanelPos({left: x, top: y});

    return true;
  }

  launchImmediateFamilyPanel(){

    const ahn = this.launchAddNodeTriTipPopModalObj.ahn;

    this.setState({
      highlight:ahn
    })

    let {x,y, rotation } = this.getXYaddNodePanelCoor(this.launchAddNodeTriTipPopModalObj);

    if( this.launchAddNodeTriTipPopModalObj.isFocus ){

        // console.log(`%c isFocus`, [
        //   'color: white',
        //   'background: green',
        //   'font-size: 14px',
        //   'border: 5px solid red',
        //   'padding: 10px',
        //   ].join(';'));

      x = this.centerX + 50; y = this.centerY - 50
    }

    // console.log(`triggerClick: `, {x,y, rotation, ahn });

    this.launchAddNodeTriTipPopModalObj = {...this.launchAddNodeTriTipPopModalObj, x, y, rotation}
    this.launchAddNodeTriTipPopModal(this.launchAddNodeTriTipPopModalObj);

    this.allowComponentUpdate(false);

  }

  setHighlightFocus({how}){
    this.setState({
      highlightFocus: how,
      highlight: 0,
      highlightOtherAhn: 0,
    })
  }

  setHighlightGhost(ahn){
    this.setState({
      highlightGhost: ahn,
      highlightOtherAhn: 0,
    })
  }

  setHighlight(ahn){
    this.setState({
      highlight: ahn,
    })
  }

  setDragOverHighlight(ahn){
    this.setState({
      dragOverHighlight: ahn,
    })
  }

  setHighlightOther(ahn){
    this.setState({
      highlightOtherAhn: ahn
    })
  }

  setHighlightFrozen(ahn){
    this.setState({
      highlightFrozen: ahn,
      highlightOtherAhn: 0,
    })
  }

  hashObjExist = this.ahnObj && this.rotationHash && this.radiusHash;
  createHashObjs({levels}){
    // this.ahnObj = this.generateahnHash(levels);
    this.ahnObj = this.generateAhnStructure(levels);
    this.addColorsToAhn(this.ahnObj, 8);
    this.rotationHash = this.generateRotationHash(levels);
    this.radiusHash = this.generateRadiusHash(levels);
    // setTimeout(() => {
    //   console.log(`this.ahnObj: `, JSON.stringify(this.ahnObj, null, 2));
    // }, 1000);
    // console.log(`this.rotationHash: `, JSON.stringify(this.rotationHash, null, 2));
    // console.log(`this.radiusHash: `, JSON.stringify(this.radiusHash, null, 2));
  }
  generateRadiusHash(level) {
    let baseInnerRadius = 80;
    let baseOuterRadius = 139;
    const increment2to4 = 50;
    const increment5orMore = 70;

    let radiusHash = {};

    for (let i = 2; i <= level; i++) {
        if (i >= 5) {
            radiusHash[i] = {
              innerRadius: baseInnerRadius,
              outerRadius: baseOuterRadius + increment5orMore
            };
            baseInnerRadius = baseOuterRadius + increment5orMore;
            baseOuterRadius = baseInnerRadius + increment2to4;
        } else {
            radiusHash[i] = {
              innerRadius: baseInnerRadius,
              outerRadius: baseOuterRadius
            };
            baseInnerRadius = baseOuterRadius;
            baseOuterRadius += increment2to4;
        }
    }

    return radiusHash;
  }
  tilt = 45;
  generateRotationHash(levels) {
    const rotationHash = {};
    const maxKey = Math.pow(2, levels);

    for (let ahn = 2; ahn <= maxKey; ahn++) {
      let baseKey = ahn % 31 || 31; // Maps keys back to the range [2, 31]
      let rotation;

      if (baseKey === 2 || baseKey === 4 || baseKey === 8 || baseKey === 16) {
        rotation = 90 + this.tilt / 2;
      } else if (baseKey === 3 || baseKey === 6 || baseKey === 12 || baseKey === 24) {
        rotation = 0;
      } else if (baseKey === 5 || baseKey === 10 || baseKey === 20) {
        rotation = 45 + this.tilt / 4;
      } else if (baseKey === 7 || baseKey === 14 || baseKey === 28) {
        rotation = -45 - this.tilt / 4;
      } else if (baseKey === 9 || baseKey === 18) {
        rotation = 67.5 + this.tilt / 2.75;
      } else if (baseKey === 11 || baseKey === 22) {
        rotation = 22.5 + this.tilt / 7.75;
      } else if (baseKey === 13 || baseKey === 26) {
        rotation = -22.5 - this.tilt / 7.75;
      } else if (baseKey === 15 || baseKey === 30) {
        rotation = -67.5 - this.tilt / 2.75;
      } else if (baseKey === 17 || baseKey === 31) {
        rotation = 78.75 + this.tilt / 2.25;
      } else if (baseKey === 19) {
        rotation = 56 + this.tilt / 3.25;
      } else if (baseKey === 21) {
        rotation = 33.75 + this.tilt / 5.5;
      } else if (baseKey === 23) {
        rotation = 11.5 + this.tilt / 16;
      } else if (baseKey === 25) {
        rotation = -11.5 - this.tilt / 16;
      } else if (baseKey === 27) {
        rotation = -33.75 - this.tilt / 5;
      } else if (baseKey === 29) {
        rotation = -56 - this.tilt / 3;
      } else {
        // Default rotation if no condition matches
        rotation = 0;
      }

      rotationHash[ahn] = { rotation };
    }

    return rotationHash;
  }
  getAscendantKeys({ key, obj }) {
    const strKey = key.toString();
    let descendants = [];
    descendants.push(strKey)

    function findNode(currentKey, currentObj) {
      if (currentObj && currentObj.hasOwnProperty(currentKey)) {
        return currentObj[currentKey];
      } else {
        for (const childKey in currentObj) {
          const foundNode = findNode(currentKey, currentObj[childKey].ancestorParents);
          if (foundNode) {
            return foundNode;
          }
        }
      }
      return null;
    }

    const startingNode = findNode(strKey, obj);

    if (startingNode) {

      function collectDescendants(currentObj) {
        if (currentObj.ancestorParents && Object.keys(currentObj.ancestorParents).length > 0) {
          for (const childKey in currentObj.ancestorParents) {
            descendants.push(childKey);  // Add the child key to the list
            collectDescendants(currentObj.ancestorParents[childKey]);  // Recursively collect further descendants
          }
        }
      }

      collectDescendants(startingNode);
    }

    return descendants.sort((a, b) => parseInt(a) - parseInt(b));;
  }

  generateAhnStructure(levels) {
    const that = this;

    function createLevel(currentLevel, ahn, maxDepth, side) {
      if (currentLevel >= levels) {
        return {};
      }

      let ancestorParents = {};
      let leftKey = ahn * 2;
      let rightKey = ahn * 2 + 1;

      ancestorParents[leftKey] = {
        ancestorParents: createLevel(currentLevel + 1, leftKey, maxDepth, side),
        currentLevel: currentLevel + 1,
        side,
        gender: that.isEven(leftKey) ? 'm' : 'f'
      };

      ancestorParents[rightKey] = {
        ancestorParents: createLevel(currentLevel + 1, rightKey, maxDepth, side),
        currentLevel: currentLevel + 1,
        side,
        gender: that.isEven(rightKey) ? 'm' : 'f'
      };

      return ancestorParents;
    }

    let root = {
      "1": {
        ancestorParents: {
          "2": {
            ancestorParents: createLevel(2, 2, levels, 'm'),
            currentLevel: 2,
            side: 'm',
          },
          "3": {
            ancestorParents: createLevel(2, 3, levels, 'f'),
            currentLevel: 2,
            side: 'f',
          }
        }
      }
    };

    return root;
  }

  addColorsToAhn(ahnObj, levels) {

    function generateColor({ baseColor, depth, maxDepth }) {
      const fadeAmount = 30; // Define how much lightness fades per level
      let lightness = 100 - (depth * fadeAmount / maxDepth); // Lightness decreases with depth

      let hue;
      if (baseColor === 'blue') {
        hue = 210;
      } else if( baseColor === 'purple') {
        hue = 270;
      } else if( baseColor === 'orange') {
        hue = 30;
      } else {
        hue = 0;
      }

      return `hsl(${hue}, 100%, ${lightness}%)`;
    }

    const descendantKeys_5 = this.getAscendantKeys({key: 5, obj: ahnObj})
    const descendantKeys_6 = this.getAscendantKeys({key: 6, obj: ahnObj})

    function applyColors(obj, depth, maxDepth) {
      for (const key in obj) {
        let baseColor = obj[key].side === 'm' ? 'blue' : 'red'; // Left (even keys) = blue, right (odd keys) = red
        if( descendantKeys_5.includes(key.toString())){
          baseColor = 'purple';
        }
        if( descendantKeys_6.includes(key.toString())){
          baseColor = 'orange';
        }
        obj[key].color = generateColor({ baseColor, depth, maxDepth });

        if (obj[key].ancestorParents) {
          applyColors(obj[key].ancestorParents, depth + 1, maxDepth);
        }
      }
    }

    applyColors(ahnObj, 1, levels);
  }

  forceUpdateFanChart(){
    this.forceUpdate();
  }
  isEven(num) {
    return num % 2 === 0;
  }
  generateNestedHash(levels) {
    function createLevel(currentLevel, currentValue) {
      if (currentLevel >= levels) {
          return {};
      }

      let ancestorParents = {};
      ancestorParents[currentValue * 2] = {
          ancestorParents: createLevel(currentLevel + 1, currentValue * 2)
      };
      ancestorParents[currentValue * 2 + 1] = {
          ancestorParents: createLevel(currentLevel + 1, currentValue * 2 + 1)
      };

      return ancestorParents;
    }

    let root = {
      "1": {
          ancestorParents: createLevel(1, 1)
      }
    };

    return root;
  };
  getAncestorParentsahns(number, obj) {
      const strNumber = number.toString();
      if (obj.hasOwnProperty(strNumber)) {
          return Object.keys(obj[strNumber].ancestorParents);
      } else {
          for (const key in obj) {
              const ancestorParents = this.getAncestorParentsahns(number, obj[key].ancestorParents);
              if (ancestorParents.length > 0) {
                  return ancestorParents;
              }
          }
      }
      return [];
  };
  isOddAhn(ahn){
        return ahn % 2
  }
  countTouch = 0;
  clickArc({
    fromWhere,
    isFocus,
    lastGhostParent,
    parentNode,
    gender,
    level,
    outterTextRotation,
    distanceFromCenter,
    sideOfCircle,
    sideHorizShift,
    prId,
  }){

    let childAlsoGhost = false;
    childAlsoGhost = parentNode.node.childNode && parentNode.node.childNode.lastGhostParent

    if( childAlsoGhost ) return;

    if( (isMobilePhone())){
      const node = parentNode.node.n;
      this.props.userTouchedNode({
        node,
        callback: ()=>{
          this.countTouch++;

          let screenIsOn = `mainFromHome`;
          if(lastGhostParent) {
            screenIsOn = `addFormFromGhost`;
          } else {
            // storePrIdToLocationHistory({userExitsFlipCard: false, prId: nodeObj.prId})
          }

          this.props.setFlipCardScreenIsOn({screenIsOn});
          this.props.setNodeForFlipFocus(node);
          this.props.setShowMobileFlipCard(node);

          if(!isDevelopment && lastGhostParent){

            setTimeout(() => {
              const relationShip = gender === 'm' ? 'father' : 'mother';
              window.openAddNode(parentNode.node.childNode.pr_id, relationShip);
            }, 700);
          }
        },

        fromWhere: 'fanchart'});
      return;
    }

    const ahn = parentNode.node.ahn;
    if(isFocus) sideOfCircle = 'left';
    this.launchAddNodeTriTipPopModalObj = {
                isFocus,
                prId,
                parentNode,
                sideOfCircle,
                ahn,
                level,
                outterTextRotation,
                distanceFromCenter,
                fromWhere,
                lastGhostParent,
                gender,
                sideHorizShift,
    };


    if( (isMobileTablet())){
      const node = parentNode.node.n;
      this.props.userTouchedNode({
        node,
        callback: ()=>{

          if( lastGhostParent ){
            const relationShip = gender === 'm' ? 'father' : 'mother';
            window.openAddNode(parentNode.node.childNode.pr_id,
              relationShip);
          } else {
            this.setHighlightFrozen(ahn);
            this.allowComponentUpdate(false)
            this.openFlipPanel(node);
          }

        },
        fromWhere: 'fanchart'});
      return;
    }



    if( lastGhostParent ){
      const relationShip = gender === 'm' ? 'father' : 'mother';
      window.openAddNode(parentNode.node.childNode.pr_id,
        relationShip);
    } else {
      this.setHighlightFrozen(ahn);
      this.allowComponentUpdate(false)
      this.openFlipPanel(parentNode.node.n);
    }



  }
  openFlipPanel(node){
    if( isDevelopment ){
      console.log(`node: `, node);
    } else {
      if(!isMobilePhone()) this.props.onClickedNode(node)
    }
  };

  adaptXYposToArcAhn({ahn, x, y,}){

    const piePartOfThisTip = (ahnBaseKey)=>{
      const pieArray = this.getAscendantKeys({key: ahnBaseKey, obj: this.ahnObj})
      const bool = pieArray.includes(ahn.toString());
      return bool
    }

    /* LEFT */
    if( piePartOfThisTip(2)) {
      x += 100;
      y -= 70;
    }
      if( piePartOfThisTip(5)) {
        y += 40;
      }
        if( piePartOfThisTip(11)) {
          x -= 40;
          y += 40;
        }
          if( piePartOfThisTip(44)) {
            x -= 10;
            y += 40;
          }
        if( piePartOfThisTip(10)) {
          x -= 30;
          y += 15;
        }
          if( piePartOfThisTip(42)) {
            x += 10;
            y += 40;
          }
          if( piePartOfThisTip(41)) {
            x += 20;
            y += 40;
          }
          if( piePartOfThisTip(43)) {
            x -= 10;
            y += 35;
          }
      if( piePartOfThisTip(4)) {
        x -= 40;
        y += 70;
      }
        if( piePartOfThisTip(9)) {
          x -= 20;
          y -= 20;
        }
          if( piePartOfThisTip(16)) {
            x += 50;
            y -= 20;
          }
          if( piePartOfThisTip(17)) {
            x += 50;
            y -= 20;
          }
          if( piePartOfThisTip(18)) {
            x += 50;
            y -= 20;
          }
          if( piePartOfThisTip(19)) {
            x += 50;
            y -= 20;
          }
            if( piePartOfThisTip(38)) {
              x += 40;
              y += 40;
            }
            if( piePartOfThisTip(39)) {
              x += 40;
              y += 40;
            }
        if( piePartOfThisTip(8)) {
          x -= 30;
          y -= 40;
        }





    /* RIGHT */
    if( piePartOfThisTip(3)) {
      x -= 50;
      y -= 50;
    }


      if( piePartOfThisTip(6)) {
        x += 30;
        y += 50;
      }

        if( piePartOfThisTip(24)) {
          x += 30;
          y += 50;
        }

        if( piePartOfThisTip(25)) {
          x += 30;
          y += 50;
        }

      if( piePartOfThisTip(7)) {
        x -= 0;
        y -= 0;
      }

        if( piePartOfThisTip(13)) {
          x += 10;
          y += 40;
        }

          if( piePartOfThisTip(26)) {
            x -= 20;
            y += 40;
          }

          if( piePartOfThisTip(27)) {
            x -= 20;
            y += 40;
          }


        if( piePartOfThisTip(14)) {
          x += 10;
          y += 40;
        }



          if( piePartOfThisTip(28)) {
            x -= 30;
            y += 40;
          }

          if( piePartOfThisTip(29)) {
            x -= 40;
            y += 30;
          }


            if( piePartOfThisTip(58)) {
              x -= 30;
              y -= 10;
            }



            if( piePartOfThisTip(59)) {
              x -= 30;
              y -= 20;
            }


        if( piePartOfThisTip(15)) {
          x += 10;
          y += 40;
        }


          if( piePartOfThisTip(30)) {
            x -= 50;
            y += 0;
          }

          if( piePartOfThisTip(31)) {
            x -= 40;
            y -= 30;
          }


    return {x, y}

  }

  launchAddNodeTriTipPopModal({prId, x, y, parentNode, sideOfCircle}){

      const scaleX = this.props.stage.current.scaleX();
      const ahn = parentNode.node.ahn

      x = this.adaptXYposToArcAhn({ahn, x, y,}).x;
      y = this.adaptXYposToArcAhn({ahn, x, y,}).y;

      if( sideOfCircle === 'right'){
        x -= (400 / scaleX);
      }

      const node = parentNode.node.n;

      const stageLeft =  Math.round(this.props.stage.current.position().x / scaleX) * -1;
      const stageTop =  (Math.round(this.props.stage.current.position().y / scaleX) * -1);
      const left = (x - stageLeft) * scaleX;
      const top =  (y - stageTop) * scaleX;

      this.props.hidePedigreeAddbox();

      setTimeout(() => {
        this.props.setPedigreeAddbox({left, top, visible: true, node, sideOfCircle});
      }, 400);
  }

  refocusFanChartClick({prId}){
    if(prId){
      this.props.refocusFanChart({prId});
    }
  };
  getRadius({level}){
    let radius = (Math.min(this.centerX - this.margin, this.centerY - (this.margin * 1.5)) * (this.ringSize) * level);
    console.log(`radius: `, radius);
    return radius;
  }
  levelHash = {
    2: {
      substring: 20,
      leftArcAnglePadding: 30,
      spacingDegree: 2.5,
      pastLetterRatio: 3,
    },
    3: {
      substring: 17,
      leftArcAnglePadding: 3,
      spacingDegree: 2,
      pastLetterRatio: 5.2,
    },
    4: {
      substring: 9,
      leftArcAnglePadding: 0,
      spacingDegree: 1.5,
      pastLetterRatio: 7,
    },
    5: {
      substring: 13,
      leftArcAnglePadding: 0,
    },
    6: {
      substring: 14,
    },
    7: {
      substring: 15,
    },
    8: {
      substring: 18,
    },
  }

  buildBlankSpaces({howMany}){
    let blankSpace = '';
    for( let i = 0; i < howMany; i++){
      blankSpace = blankSpace + ' ';
    }
    return blankSpace;
  }

  getStraightText({
    level,
    index,
    straightPathNameObj,
    dateAliveText,
    textName,
    fontFamily,
    cursor,
    prId,
    ahn,
    layer,
    parentNode,
    sideOfCircle,
    angle,
    outterTextRotation,
    distanceFromCenter,
    sideHorizShift,
  }){

    if( typeof(this.testAhn) !== 'undefined'  && ahn !== this.testAhn) return null;

    const lastGhostParent = parentNode.node.lastGhostParent;
    const maxCharsPerRow = this.levelHash[level]['substring']
    const names = this.getRowsForName({fullName: textName, maxCharsPerRow});

    const oneRowExist = names.length === 1 && !lastGhostParent;
    const secondRowExist = names.length > 1 && !lastGhostParent;


    if( ahn === this.testAhn){
      // console.clear();
      // console.log(`ahn: `, ahn);
      // console.log(`level: `, level);
      // console.log(`textName: `, textName);
      // console.log(`max: `, this.levelHash[level]['substring']);
      const shortenedName = `${textName.substring(this.levelHash[level]['substring'], 0)}`;
      // console.log(`shortenedName: `, shortenedName);
      // console.log(`names: `, JSON.stringify(names, null, 2));
    }


    const changePlusToAddSomeone = (lastGhostParent && ahn.toString() === this.state.highlightGhost) ||
        (lastGhostParent && level === 2);

    let rows;
    if( level < 7 ) rows = [1, 2, 3];
    else if ( level === 7 ) rows = [1, 2];
    else if ( level === 8 ) rows = [1];

    if( level < 8 && dateAliveText && !secondRowExist)  rows = [1, 2];

    if(lastGhostParent) rows = [1];

    const rowComponentArr = rows.map((row)=>{

      let text;
      const levelsThatCanHaveDatesInStraightText = [5, 6];

      let useDate =
                (dateAliveText &&
                row === 2 &&
                levelsThatCanHaveDatesInStraightText.includes(level) &&
                !secondRowExist)
                        ||
                (dateAliveText &&
                row === 3 &&
                levelsThatCanHaveDatesInStraightText.includes(level) &&
                secondRowExist)

      if( useDate ){
        text = this.buildBlankSpaces({howMany: 0}) + dateAliveText;
      } else if( changePlusToAddSomeone ){
        text = parentNode.node.g === 'f' ? this.addMotherStr: this.addFatherStr;
        text = text.slice(0, this.levelHash[level]['substring'] -1);
      } else {
        text = names[row - 1]
      }

      let fontsize = this.fontSize - ( useDate ? 2: 0);
      let fontStyle =  useDate ? 'normal': 'bold';
      if( level === 8 ){
        fontsize -= 2;
      }
      if( level === 7 ){
        fontsize -= 1;
      }
      if( lastGhostParent && !changePlusToAddSomeone){
        fontsize = 17;
        fontStyle = 'normal';
      }

      let rotation = straightPathNameObj[row]['outterTextRotation'];

      if( sideOfCircle === 'right'){
        if ( level === 7 ) rotation -= 2;
        if ( level === 8 ) rotation -= 3.2;
      } else {
        if ( level === 5 ) rotation += 2;
        if ( level === 6 ) rotation += 2;
        if ( level === 7 ) rotation += 2.5;
        if ( level === 8 ) rotation += 1;
      }

      const x = straightPathNameObj[row]['lineX'];
      const y = straightPathNameObj[row]['lineY'];

      if(text && !useDate) text = text.slice(0, maxCharsPerRow);

      if( ahn === this.testAhn){
        // console.log(`{x, y}: `, JSON.stringify({x, y}, null, 2));
        // console.count('loop');
        // console.log(`row: `, row);
        // console.log(`text: `, text);
        // console.log(`x: `, x);
      }

      // console.log(`x: `, x, `-ahn: `, ahn);
      let fullName = this.ahnOnly ? parentNode.node.ahn :text;
      if(urlGet('nodeIs') === "n") fullName = `N: ${parentNode.node.n}`;
      // text={`${parentNode.node.ahn}`}
      // text={parentNode.node.ahn + ` -  A:${angle} - S:${sideOfCircle}`}
      // text={parentNode.node.ahn + `-${angle}`}

      let ahnObj = {
                isFocus: false,
                lastGhostParent: parentNode.node.lastGhostParent,
                parentNode,
                gender: this.isOddAhn(parentNode.node.ahn) ? 'f': 'm',
                level,
                outterTextRotation,
                distanceFromCenter,
                sideOfCircle,
                sideHorizShift,
                prId,
                layer
              }

      return <Text
              key={`arctext-str-${index}-${row}`}
              x={x}
              y={y}
              rotation={rotation}
              text={fullName}
              fontSize={fontsize}
              fontStyle={fontStyle}
              fontFamily={fontFamily}
              align="center"
              verticalAlign="middle"
              letterSpacing={1}
              cursor={cursor}
              onTouchStart={this.clickArc.bind(this, ahnObj)}
              onClick={this.clickArc.bind(this, ahnObj)}


              onMouseenter={()=>{
                this.mouseEnterChangeHighlight(ahnObj);
              }}

              // onMouseenter={this.mouseEnterChangeHighlight.bind(this, {parentNode, lastGhostParent, layer, fromWhere: 'straight text'})}

              // onMouseleave={()=>{
              //   this.props.cursorBecomesMove();
              // }}
            />
    });
    return rowComponentArr;

  }
  getAncestorParentsColor(number, obj) {
    const strNumber = number.toString();
    let stack = [obj];

    while (stack.length > 0) {
      let currentObj = stack.pop();

      if (currentObj.hasOwnProperty(strNumber)) {
        return currentObj[strNumber].color;
      }

      for (const key in currentObj) {
        if (currentObj[key].ancestorParents) {
          stack.push(currentObj[key].ancestorParents);
        }
      }
    }

    return null;
  }

  getRowsForName({fullName, maxCharsPerRow}){

      fullName.trim();
      const words = fullName.split(' ');
      const rows = [];
      let currentRow = '';

      for (const word of words) {
        if (currentRow.length + word.length + 1 > maxCharsPerRow) {
          rows.push(currentRow.trim());
          currentRow = word + ' ';
        } else {
          currentRow += word + ' ';
        }
      }

      if (currentRow.trim()) {
        rows.push(currentRow.trim());
      }

      // Remove any blank elements from the array
      return rows.filter(row => row !== '');
  }

  getArcText({layer,
    parentNode,
    ahn,
    level,
    ahnRotation,
    innerRadius,
    midRadiusOfInnerAndOutterRing,
    prId,
    dateAliveText,
    hasDate,
    outterTextRotation,
    distanceFromCenter,
    sideOfCircle,
    sideHorizShift,
}) {

    if( parentNode.node.nm === '') return null;

    let row1;
    let row2;
    let row3;

    ahnRotation += 4;

    switch(ahn) {
      case 2:
          ahnRotation -= 20;
          break;
      case 3:
          ahnRotation -= 20;
          break;
      default:
    }

    let maxCharsPerRow = this.levelHash[level]['substring'];

    const rows = this.getRowsForName({fullName: parentNode.node.nm, maxCharsPerRow});
    row1 = rows[0];
    row2 = rows[1];
    row3 = rows[2];

    if(row3) {
      row3 = row3.slice(0, maxCharsPerRow);
    }

    const secondRowIsEmpty = typeof(row2) === 'undefined';
    const dateAliveTextIsEmpty = dateAliveText === '';
    const thirdRowNameExist = typeof(row3) !== 'undefined';

    const surplusSpaces1 = maxCharsPerRow - row1.length;
    const surplusSpaces2 = maxCharsPerRow - (!secondRowIsEmpty ? row2.length: 0);
    const surplusSpaces3 = maxCharsPerRow - (thirdRowNameExist ? row3.length: 0);

    let startXPosRow1 = ahnRotation + surplusSpaces1 + 2;
    let startXPosRow2 = ahnRotation + surplusSpaces2 + 2;
    let startXPosRow3 = ahnRotation + surplusSpaces3 + 1.75;


    let lastGhostParent;
    if(parentNode.node.lastGhostParent){
      startXPosRow1 = ahnRotation;
      startXPosRow2 = ahnRotation;
      lastGhostParent = parentNode.node.lastGhostParent;
    }

    let ghostLabelToWords = (lastGhostParent && ahn.toString() === this.state.highlightGhost) ||
        (lastGhostParent && level === 2) ||
        (lastGhostParent && level === 3);

    if(ghostLabelToWords){
      row1 = parentNode.node.g ==='f' ? this.addMotherStr: this.addFatherStr;
      if( level <= 3 ) row1 = '+ ' + row1;
      maxCharsPerRow += 2;
      row1 = row1.slice(0, maxCharsPerRow);
      const lengthOfRow1 = row1.length;
      const surplusSpaces1 = maxCharsPerRow - lengthOfRow1;
      startXPosRow1 = ahnRotation + surplusSpaces1;
    }


    let rotation = 0;
    let pastLetter = ' ';


    let topOfTextOffset = ( lastGhostParent || secondRowIsEmpty ? 0: -9);
    if( dateAliveTextIsEmpty && !secondRowIsEmpty ) topOfTextOffset = -5;
    if( thirdRowNameExist ) topOfTextOffset = -10;

    const fontsizeName = this.fontSize;
    const fontsizePlus = this.fontSize + 2;
    const useFont = ( lastGhostParent && !ghostLabelToWords ? fontsizePlus: fontsizeName);

    let ahnObj = {
      isFocus: false,
      lastGhostParent: parentNode.node.lastGhostParent,
      parentNode,
      gender: this.isOddAhn(parentNode.node.ahn) ? 'f': 'm',
      level,
      outterTextRotation,
      distanceFromCenter,
      sideOfCircle,
      sideHorizShift,
      prId,
      layer
    }

    const firstRowLtrComponents = row1.split('').map((letter, idx) => {

      rotation = this.appyLetterDegreeSpacing({nm: row1, lastGhostParent, ghostLabelToWords, pastLetter, idx, level, ahnRotation: startXPosRow1, letter, rotation});
      pastLetter = letter;

      let offset = topOfTextOffset;
      offset -= midRadiusOfInnerAndOutterRing;
      const data = `M 0,-${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,-${innerRadius - offset}`;
      return [<TextPath
              key={`arctextPath-${idx}`}
              onMouseenter={this.mouseEnterChangeHighlight.bind(this, ahnObj)}
              onMouseleave={()=>{
                this.props.cursorBecomesMove();
              }}
              onTouchStart={this.clickArc.bind(this, ahnObj)}
              onClick={this.clickArc.bind(this, ahnObj)}
              x={this.centerX}
              y={this.centerY}
              fontSize={useFont}
              letterSpacing={1}
              fontStyle="bold"
              fontFamily={fontFamily}
              fill="black"
              text={`${letter}`}
              align="left"
              verticalAlign="middle"
              rotation={rotation}
              data={data}
            />]
    });

    let secondRowLtrComponents = [];
    if( !secondRowIsEmpty ){
        secondRowLtrComponents = row2.split('').map((letter, idx) => {

              rotation = this.appyLetterDegreeSpacing({nm: row2, lastGhostParent, ghostLabelToWords, pastLetter, idx, level, ahnRotation: startXPosRow2, letter, rotation});
              pastLetter = letter;

              let offset = topOfTextOffset + 13;
              offset -= midRadiusOfInnerAndOutterRing;
              const data = `M 0,-${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,-${innerRadius - offset}`;
              return [<TextPath
                      key={`arctextPath-${idx}`}
                      onMouseenter={this.mouseEnterChangeHighlight.bind(this, ahnObj)}
                      onMouseleave={()=>{
                        this.props.cursorBecomesMove();
                      }}
                      onTouchStart={this.clickArc.bind(this, ahnObj)}
                      onClick={this.clickArc.bind(this, ahnObj)}
                      x={this.centerX}
                      y={this.centerY}
                      fontSize={useFont}
                      letterSpacing={1}
                      fontStyle="bold"
                      fontFamily={fontFamily}
                      fill="black"
                      text={`${letter}`}
                      align="left"
                      verticalAlign="middle"
                      rotation={rotation}
                      data={data}
                    />]
            });
    }


    let thirdRowLtrComponents = [];
    let dateRowLtrComponents = [];

    if( thirdRowNameExist ){
        thirdRowLtrComponents = row3.split('').map((letter, idx) => {

              rotation = this.appyLetterDegreeSpacing({nm: row2, lastGhostParent, ghostLabelToWords, pastLetter, idx, level, ahnRotation: startXPosRow3, letter, rotation});
              pastLetter = letter;

              let offset = topOfTextOffset + 25;
              offset -= midRadiusOfInnerAndOutterRing;
              const data = `M 0,-${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,-${innerRadius - offset}`;
              return [<TextPath
                      key={`arctextPath-${idx}`}
                      onMouseenter={this.mouseEnterChangeHighlight.bind(this, ahnObj)}
                      onMouseleave={()=>{
                        this.props.cursorBecomesMove();
                      }}
                      onTouchStart={this.clickArc.bind(this, ahnObj)}
                      onClick={this.clickArc.bind(this, ahnObj)}
                      x={this.centerX}
                      y={this.centerY}
                      fontSize={useFont}
                      letterSpacing={1}
                      fontStyle="bold"
                      fontFamily={fontFamily}
                      fill="black"
                      text={`${letter}`}
                      align="left"
                      verticalAlign="middle"
                      rotation={rotation}
                      data={data}
                    />]
            });
    } else {

        const surplusSpacesDate = dateAliveText.length - maxCharsPerRow;
        let startXPosRowDate = ahnRotation + surplusSpacesDate;

        dateRowLtrComponents = dateAliveText.split('').map((letter, idx) => {

          let shiftAhnRotation = 0

          switch(level) {
            case 2:
                shiftAhnRotation = 17
                break;
            case 3:
                shiftAhnRotation = 10
                break;
            case 4:
                shiftAhnRotation = -1
                break;
            default:
          }

          rotation = this.appyLetterDegreeSpacing({nm: dateAliveText, lastGhostParent, ghostLabelToWords, pastLetter, idx, level, /*ahnRotation: startXPosRowDate,*/ ahnRotation: ahnRotation + shiftAhnRotation, letter, rotation});
          pastLetter = letter;

          let offset = topOfTextOffset + ( secondRowIsEmpty ? 13: 25);
          offset -= midRadiusOfInnerAndOutterRing;
          const data = `M 0,-${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,-${innerRadius - offset}`;
          return [<TextPath
                  key={`arctextPath-${idx}`}
                  onMouseenter={this.mouseEnterChangeHighlight.bind(this, ahnObj)}
                  onMouseleave={()=>{
                    this.props.cursorBecomesMove();
                  }}
                  onTouchStart={this.clickArc.bind(this, ahnObj)}
                  onClick={this.clickArc.bind(this, ahnObj)}
                  x={this.centerX}
                  y={this.centerY}
                  letterSpacing={1}
                  fontFamily={fontFamily}
                  fontSize={this.fontSize - 2}
                  fontStyle={'normal'}
                  fill="black"
                  text={`${letter}`}
                  align="left"
                  verticalAlign="middle"
                  rotation={rotation}
                  data={data}
                />]
        });
    }

    const ahnRow = ahn.toString().split('').map((letter, idx) => {

      rotation = this.appyLetterDegreeSpacing({nm: row1, lastGhostParent, ghostLabelToWords, pastLetter, idx, level, ahnRotation, letter, rotation});
      pastLetter = letter;

      let offset = topOfTextOffset;
      offset -= midRadiusOfInnerAndOutterRing;
      const data = `M 0,-${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,${innerRadius - offset} A ${innerRadius - offset},${innerRadius - offset} 0 1,1 0,-${innerRadius - offset}`;
      return [<TextPath
              key={`arctextPath-${idx}`}
              onMouseenter={this.mouseEnterChangeHighlight.bind(this, ahnObj)}
              onMouseleave={()=>{
                this.props.cursorBecomesMove();
              }}
              onTouchStart={this.clickArc.bind(this, ahnObj)}
              onClick={this.clickArc.bind(this, ahnObj)}
              x={this.centerX}
              y={this.centerY}
              fontSize={this.fontSize}
              letterSpacing={1}
              fontStyle="bold"
              fontFamily={fontFamily}
              fill="black"
              text={`${letter}`}
              align="left"
              verticalAlign="middle"
              rotation={rotation}
              data={data}
            />]
    });

    if( this.ahnOnly ) return [ahnRow];
    return [firstRowLtrComponents, secondRowLtrComponents, dateRowLtrComponents, thirdRowLtrComponents];
  }

  appyLetterDegreeSpacing({nm, lastGhostParent, ghostLabelToWords, pastLetter, idx, letter, level, ahnRotation, rotation}){

    let spacingDegree = this.levelHash[level]['spacingDegree'];

    if( idx === 0){
      rotation = ahnRotation
    } else if( idx === 1){
      rotation = ahnRotation + this.props.hashWidthsNamesForFanchart[pastLetter]/this.levelHash[level]['pastLetterRatio']
    } else {

      let previousLetterWidth = this.props.hashWidthsNamesForFanchart[pastLetter]/this.levelHash[level]['pastLetterRatio'];
      if( !previousLetterWidth ) previousLetterWidth = spacingDegree;

      rotation = rotation + previousLetterWidth;
    }

    if (isNaN(rotation))  rotation = ahnRotation;
    if (lastGhostParent && level === 2 && !ghostLabelToWords)  rotation = ahnRotation + 20;
    if (lastGhostParent && level === 3 && !ghostLabelToWords)  rotation = ahnRotation + 20;
    if (lastGhostParent && level === 4 && !ghostLabelToWords)  rotation = ahnRotation + 9.5;

    return rotation;

  }

  getXYaddNodePanelCoor({level, outterTextRotation, distanceFromCenter, sideOfCircle, sideHorizShift}){

      let x, y, rotation;
      let iconAdaptHash = {};

      // ahnColor = 'black'

      iconAdaptHash = {
        2:{
          'left':{
            turn: 0,
            distanceFromCenter: 44.5,
            sideHorizShift: -7,
          },
          'right':{
            turn: -.6,
            distanceFromCenter: 44.5,
            sideHorizShift: -7,
          },
        },
        3:{
          'left':{
            turn: 0,
            distanceFromCenter: 44.5,
            sideHorizShift: -6,
          },
          'right':{
            turn: -.6,
            distanceFromCenter: 44.5,
            sideHorizShift: -6,
          },
        },
        4:{
          'left':{
            turn: 180,
            distanceFromCenter: 54.5,
            sideHorizShift: -4.6,
          },
          'right':{
            turn: -.6,
            distanceFromCenter: 84.5,
            sideHorizShift: -4.6,
          },
        },
        5:{
          'left':{
            turn: 268.4,
            distanceFromCenter: 17,
            sideHorizShift: -3,
          },
          'right':{
            turn: -270,
            distanceFromCenter: 118,
            sideHorizShift: -3,
          },
        },
        6:{
          'left':{
            turn: 270,
            distanceFromCenter: 18,
            sideHorizShift: -2.2,
          },
          'right':{
            turn: -270,
            distanceFromCenter: 118,
            sideHorizShift: -2.2,
          },
        },
        7:{
          'left':{
            turn: 270,
            distanceFromCenter: 18,
            sideHorizShift: -1.9,
          },
          'right':{
            turn: -270,
            distanceFromCenter: 118,
            sideHorizShift: -1.9,
          },
        },
        8:{
          'left':{
            turn: 270,
            distanceFromCenter: 18,
            sideHorizShift: -1.6,
          },
          'right':{
            turn: -270,
            distanceFromCenter: 118,
            sideHorizShift: -1.6,
          },
        },
      }

      if( typeof(iconAdaptHash[level]) !== 'undefined' ){

        rotation = outterTextRotation + iconAdaptHash[level][sideOfCircle].turn;
        distanceFromCenter += iconAdaptHash[level][sideOfCircle].distanceFromCenter
        sideHorizShift += iconAdaptHash[level][sideOfCircle].sideHorizShift

      }

      x = this.centerX + distanceFromCenter * Math.cos((sideHorizShift * Math.PI) / 180);
      y = this.centerY + distanceFromCenter * Math.sin((sideHorizShift * Math.PI) / 180);

      return {x,y, rotation};

  }

  getCycleTabIcon({ahnColor, level, index, straightPathNameObj, dateAliveText, textName, fontFamily, cursor, prId, layer, parentNode, sideOfCircle, distanceFromCenter, sideHorizShift, outterTextRotation}){

      let {x,y, rotation } = this.getXYaddNodePanelCoor({level, outterTextRotation, distanceFromCenter, sideOfCircle, sideHorizShift});

      let dataURL = `\
          <svg width="100" height="30" xmlns="http://www.w3.org/2000/svg">
              <g id="tabIcon">
                  <path d="m1.29131,21.3814l18.31217,-20.83296l61.04056,0l18.31216,20.83296l-97.66489,0z" fill="#5AA92E"/>
                  <text x="50%" y="58%" fill="white" font-family="Arial" font-size="18" font-weight="bold" text-anchor="middle">x2</text>
              </g>
          </svg>
          `;

      let url = getImgURLdataFromSVG(dataURL);

      const svgImg = new window.Image();
            svgImg.src = url;
            svgImg.crossOrigin = "Anonymous";
            svgImg.onload = () => {}

      return (
           <Image
              cursor={'pointer'}
              x={x}
              y={y}
              rotation={rotation}
              image={svgImg}
              scaleX={.4}
              scaleY={.4}
              width={100}
              height={30}
           />
      );
  }

  getFocusTabIcon({ahnColor, level, index, straightPathNameObj, dateAliveText, textName, fontFamily, cursor, prId, layer, parentNode, sideOfCircle, distanceFromCenter, sideHorizShift, outterTextRotation}){

      let {x,y, rotation } = this.getXYaddNodePanelCoor({level, outterTextRotation, distanceFromCenter, sideOfCircle, sideHorizShift});

      let dataURL = `\
          <svg width="100" height="30" xmlns="http://www.w3.org/2000/svg">
              <g id="tabIcon">
                  <path d="m1.29131,21.3814l18.31217,-20.83296l61.04056,0l18.31216,20.83296l-97.66489,0z" fill="${ahnColor}"/>
              </g>
              <g id="treeIcon" fill="none" opacity="0.6" transform="translate(35, 10)">
                  <g id="Tree" fill="#000000">
                      <path d="M14,3 L9,3 L9,4 C9,5.104569 8.104569,6 7,6 L2,6 C0.895431,6 0,5.104569 0,4 L0,2 C0,0.895431 0.895431,0 2,0 L7,0 C8.104569,0 9,0.895431 9,2 L20,2 C20,0.895431 20.895431,0 22,0 L27,0 C28.104569,0 29,0.895431 29,2 L29,4 C29,5.104569 28.104569,6 27,6 L22,6 C20.895431,6 20,5.104569 20,4 L20,3 L15,3 L15,10 L17,10 C18.104569,10 19,10.895431 19,12 L19,14 C19,15.104569 18.104569,16 17,16 L12,16 C10.895431,16 10,15.104569 10,14 L10,12 C10,10.895431 10.895431,10 12,10 L14,10 L14,3 Z" id="profile-tree"></path>
                  </g>
              </g>
          </svg>
          `;

      let url = getImgURLdataFromSVG(dataURL);

      const svgImg = new window.Image();
            svgImg.src = url;
            svgImg.crossOrigin = "Anonymous";
            svgImg.onload = () => {}

      return (
           <Image
              cursor={'pointer'}
              x={x}
              y={y}
              rotation={rotation}


              onTouchStart={
                ()=>{
                  this.refocusFanChartClick({prId, x, y, parentNode, sideOfCircle})
                }
              }

              onClick={
                ()=>{
                  this.refocusFanChartClick({prId, x, y, parentNode, sideOfCircle})
                  // this.launchAddNodeTriTipPopModal({prId, x, y, parentNode, sideOfCircle})
                }
              }
              onMouseenter={()=>{
                this.props.cursorBecomesPointer()
              }}
              onMouseleave={()=>{
              }}
              image={svgImg}
              scaleX={.4}
              scaleY={.4}
              width={100}
              height={30}
           />
      );
  }

  hasDate({node, level, ahn}){
    if(ahn === this.testAhn) {
      console.log(`level: `, level);
      console.log(`node: `, JSON.stringify(node, null, 2));
    }
    if( level > 6) return false;
    if(typeof(node.dob_c) !== 'undefined' ) return true;
    if(typeof(node.dod_c) !== 'undefined' ) return true;
    if(typeof(node.dob_y) !== 'undefined' ) return true;
    if(typeof(node.dod_y) !== 'undefined' ) return true;
    return false;
  }

  getNumRowsFromFullNameBasedOnLevel({nm, level}){
    const length = nm.length;
    const maxCharPerRow = this.levelHash[level]['substring'];
    return Math.ceil(length/maxCharPerRow);
  }

  getLeftSideLevelShiftDown({oneRowsExist, twoRowsExist, threeRowsExist, hasDate, ahn, textNameArr, dateAliveText, level, lastGhostParent}){

    const changePlusToAddSomeone = (lastGhostParent && ahn.toString() === this.state.highlightGhost) ||
        (lastGhostParent && level === 2);

    let levelShiftUpDown;

    levelShiftUpDown = {
      4: {
        0: -1.5,
        1: 2.5,
        2: 2.75,
        3: 3,
      },
      5: {
        0: 2,
        1: 2.5,
        2: 2.75,
        3: 3,
      },
      6: {
        0: 2,
        1: 2.5,
        2: 2.75,
        3: 3,
      },
      7: {
        0: 2,
        1: 2.5,
        2: 2.75,
        3: 3,
      },
      8: {
        0: 2,
        1: 2,
      },
    }

    if(oneRowsExist){

      if(ahn === this.testAhn) {
        console.log(`oneRowsExist: `, oneRowsExist);
        console.log(`ahn: `, ahn);
        console.log(`level: `, level);
      }

      levelShiftUpDown = {
        4: {
          0: -1.5,
          1: 2.5,
        },
        5: {
          0: 2,
          1: 2.5,
          2: 2.5,
          3: 2.5,
        },
        6: {
          0: 2,
          1: 2.5,
          2: 2.5,
          3: 2.5,
        },
        7: {
          0: 2,
          1: 2.1,
          2: 2.1,
          3: 2.1,
        },
        8: {
          0: (changePlusToAddSomeone ? 1.9: 2.1),
          1: 2,
          2: 2,
          3: 2,
        },
      }
    }

    if(twoRowsExist){

      if(ahn === this.testAhn) {

           console.log(`%c twoRowsExist`, [
             'color: white',
             'background: blue',
             'font-size: 14px',
             'border: 5px solid red',
             'padding: 10px',
             ].join(';'));

        console.log(`twoRowsExist: `, twoRowsExist);
        console.log(`ahn: `, ahn);
        console.log(`level: `, level);
        console.log(`hasDate: `, hasDate);
        console.log(`dateAliveText: `, dateAliveText);
      }

        levelShiftUpDown = {
          4: {
            0: -1.5,
            1: 2.5,
            2: 2.75,
            3: 3,
          },
          5: {
            0: 2,
            1: 2.5,
            2: 2.75,
            3: 3,
          },
          6:  {
            0: 2,
            1: 3,
            2: 3,
            3: 3,
          },
          7: {
            0: 2,
            1: 2.5,
            2: 2.75,
            3: 3,
          },
          8: {
            0: 2,
            1: 2,
            2: 2,
            3: 2,
          },
        }
    }

    if(threeRowsExist){

      if(ahn === this.testAhn) {
        console.log(`threeRowsExist: `, threeRowsExist);
        console.log(`ahn: `, ahn);
        console.log(`level: `, level);
      }

      levelShiftUpDown = {
        4: {
          0: -1.5,
          1: 2.5,
          2: 2.75,
          3: 3,
        },
        5: {
          0: 2,
          1: 3.75,
          2: 4.2,
          3: 4.5,
        },
        6: {
          0: 2,
          1: 3.5,
          2: 4.2,
          3: 4.5,
        },
        7: {
          0: 2,
          1: 2.5,
          2: 2.75,
          3: 3,
        },
        8: {
          0: 2,
          1: 2,
        },
      }

    }

    if(oneRowsExist && hasDate){

      if( ahn === this.testAhn){
         console.log(`%c oneRowsExist && hasDate`, [
           'color: white',
           'background: orange',
           'font-size: 14px',
           'border: 5px solid red',
           'padding: 10px',
           ].join(';'));

      }

      levelShiftUpDown = {
        4: {
          0: -1.5,
          1: 2.5,
          2: 2.75,
        },
        5: {
          0: 2,
          1: 1.5,
          2: 2,
        },
        6: {
          0: 2,
          1: 1.5,
          2: 2,
        },
        7: {
          0: 2,
          1: 2.5,
          2: 2.75,
          3: 3,
        },
        8: {
          0: 2,
          1: 2,
        },
      }
    }

    if(threeRowsExist && hasDate){

      if( ahn === this.testAhn){

         console.log(`%c threeRowsExist && hasDate`, [
           'color: white',
           'background: orange',
           'font-size: 14px',
           'border: 5px solid red',
           'padding: 10px',
           ].join(';'));

      }

        levelShiftUpDown = {
          4: {
            0: -1.5,
            1: 2.5,
            2: 2.75,
            3: 3,
          },
          5: {
            0: 2,
            1: 3.5,
            2: 3.5,
            3: 3.5,
          },
          6: {
            0: 2,
            1: 2,
            2: 2.7,
            3: 3,
          },
          7: {
            0: 2,
            1: 2.5,
            2: 2.75,
            3: 3,
          },
          8: {
            0: 2,
            1: 2,
          },
        }

    }
    if(twoRowsExist && hasDate){

      if( ahn === this.testAhn){

         console.log(`%c twoRowsExist && hasDate`, [
           'color: white',
           'background: orange',
           'font-size: 14px',
           'border: 5px solid red',
           'padding: 10px',
           ].join(';'));

      }

        levelShiftUpDown = {
          4: {
            0: -1.5,
            1: 2.5,
            2: 2.75,
            3: 3,
          },
          5: {
            0: 2,
            1: 2.5,
            2: 2.75,
            3: 3,
          },
          6:  {
            0: 2,
            1: 2.55,
            2: 2.75,
            3: 2.85,
          },
          7: {
            0: 2,
            1: 2.5,
            2: 2.75,
            3: 3,
          },
          8: {
            0: 2,
            1: 2,
          },
        }

    }

    return levelShiftUpDown;
  }

  getRightSideLevelShiftDown({oneRowsExist, twoRowsExist, threeRowsExist, hasDate, ahn, textNameArr, dateAliveText, level, lastGhostParent}){

    const changePlusToAddSomeone = (lastGhostParent && ahn.toString() === this.state.highlightGhost) ||
        (lastGhostParent && level === 2);

    let levelShiftUpDown;

    levelShiftUpDown = {
      4: {
        0: 0,
        1: 2.5,
        2: 2.75,
        3: 3,
      },
      5: {
        0: 0,
        1: .5,
        2: .5,
        3: .5,
      },
      6: {
        0: 0,
        1: .5,
        2: .5,
        3: .5,
      },
      7: {
        0: 0,
        1: .4,
        2: -.2,
        3: 3.45,
      },
      8: {
        0: (changePlusToAddSomeone ? .15: 0),
        1: .3,
      },
    }

/*

    if(oneRowsExist){
      if(ahn === this.testAhn) {
        console.log(`oneRowsExist: `, oneRowsExist);
        console.log(`ahn: `, ahn);
        console.log(`level: `, level);
        console.log(`levelShiftUpDown[level][0]: `, levelShiftUpDown[level][0]);
      }
    }
 */

    if(twoRowsExist){

      if(ahn === this.testAhn) {
        console.log(`twoRowsExist: `, twoRowsExist);
        console.log(`ahn: `, ahn);
        console.log(`level: `, level);
      }

      levelShiftUpDown = {...levelShiftUpDown,
        5: {
          0: 0,
          1: -.8,
          2: -.8,
          3: -.8,
        },
        6: {
          0: 0,
          1: -1,
          2: -1,
          3: -1,
        },
        7: {
          0: 0,
          1: -.3,
          2: -.3,
          3: -.3,
        },
        8: {
          0: 0,
          1: .3,
        },
      }
    }

    if(threeRowsExist){

      if(ahn === this.testAhn) {
        console.log(`threeRowsExist: `, threeRowsExist);
        console.log(`ahn: `, ahn);
        console.log(`level: `, level);
      }

      levelShiftUpDown = {...levelShiftUpDown,
        5: {
          0: 0,
          1: -2.75,
          2: -2.75,
          3: -2.75,
        },
        6: {
          0: 0,
          1: -2,
          2: -2,
          3: -2,
        },
        7: {
          0: 0,
          1: -.3,
          2: -.3,
        },
        8: {
          0: 0,
          1: .3,
        },
      }
    }

    if(oneRowsExist && hasDate){


      if( ahn === this.testAhn){

         console.log(`%c oneRowsExist && hasDate`, [
           'color: white',
           'background: orange',
           'font-size: 14px',
           'border: 5px solid red',
           'padding: 10px',
           ].join(';'));

      }

    }

    if(threeRowsExist && hasDate){

      if( ahn === this.testAhn){

         console.log(`%c threeRowsExist && hasDate`, [
           'color: white',
           'background: orange',
           'font-size: 14px',
           'border: 5px solid red',
           'padding: 10px',
           ].join(';'));

      }

      levelShiftUpDown = {...levelShiftUpDown,
        5: {
          0: 0,
          1: -1,
          2: -1,
          3: -1,
        },
        6: {
          0: 0,
          1: -.4,
          2: -.4,
          3: -.4,
        },
        7: {
          0: 0,
          1: -.3,
          2: -.3,
        },
        8: {
          0: 0,
          1: .3,
        },
      }
    }
/*

 */
    if(twoRowsExist && hasDate){

      if( ahn === this.testAhn){

         console.log(`%c twoRowsExist && hasDate`, [
           'color: white',
           'background: orange',
           'font-size: 14px',
           'border: 5px solid red',
           'padding: 10px',
           ].join(';'));

      }

      levelShiftUpDown = {...levelShiftUpDown,
        5: {
          0: 0,
          1: -.8,
          2: -.8,
          3: -.8,
        },
        6: {
          0: 0,
          1: -.3,
          2: -.3,
          3: -.3,
        },
        7: {
          0: 0,
          1: -.5,
          2: -.5,
          3: -.5,
        },
        8: {
          0: 0,
          1: .3,
        },
      }

    }
    return levelShiftUpDown;
  }

/*

  getArcEdgeCoordinates({sideOfCircle, x, y, outerRadius, innerRadius, angle, rotation}) {

    const startAngleRad = (rotation * Math.PI) / 180;
    const endAngleRad = ((rotation + angle) * Math.PI) / 180;


    const whichRadius = sideOfCircle === 'right' ?  outerRadius: innerRadius;
    const startX = x + whichRadius * Math.cos(startAngleRad);
    const startY = y + whichRadius * Math.sin(startAngleRad);
    const endX = x + whichRadius * Math.cos(endAngleRad);
    const endY = y + whichRadius * Math.sin(endAngleRad);

    const furthestRight = startX > endX ? { x: startX, y: startY } : { x: endX, y: endY };
    const furthestLeft = startX < endX ? { x: startX, y: startY } : { x: endX, y: endY };

    let edgeX, edgeY = undefined;
    if( sideOfCircle === 'right'){
      edgeX = furthestRight.x;
      edgeY = furthestRight.y;
    } else {
      edgeX = furthestLeft.x;
      edgeY = furthestLeft.y;
    }

    return {edgeX, edgeY};
  }
 */

  mouseEnterChangeHighlight({

    isFocus,
    prId,
    parentNode,
    sideOfCircle,
    ahn,
    level,
    outterTextRotation,
    distanceFromCenter,
    fromWhere,
    lastGhostParent,
    gender,
    sideHorizShift,
    layer,

  }){

    this.floaterAhnObj = {
      isFocus,
      prId,
      parentNode,
      sideOfCircle,
      ahn,
      level,
      outterTextRotation,
      distanceFromCenter,
      fromWhere,
      lastGhostParent,
      gender,
      sideHorizShift,
    };

    let childAlsoGhost = false;
    childAlsoGhost = parentNode.node.childNode && parentNode.node.childNode.lastGhostParent

    if (layer !== 1 || !lastGhostParent)   this.props.cursorBecomesPointer();

    if (!lastGhostParent) {
      this.setHighlight(parentNode.node.ahn);
      if( this.state.floaterActive ){
        this.setDragOverHighlight(parentNode.node.ahn);
        this.props.setDropOnNode(parentNode.node.n);
      }
      this.setHighlightGhost(0);
      const node = parentNode.node.n;
      this.highlightOtherCid({node})
    } else if( lastGhostParent && !childAlsoGhost){
      this.setHighlightGhost(parentNode.node.ahn);
      this.setHighlight(0);
      if( this.state.floaterActive ) this.setDragOverHighlight(parseInt(parentNode.node.ahn, 10));
    }
  }

  drawArcs({layer, level, angle, parents, currentFocusNodeObj, currentFocusRotation}){

    level++;

    let arcs = parents.map((parentNode, index) => {

      if( level > this.maxLevels ) return null;

      this.count++;

      let ahn = parentNode.node.ahn;
      ahn = parseInt(ahn, 10)
      const lastGhostParent = parentNode.node.lastGhostParent;
      const gender = parentNode.node.g;
      const prId = parentNode.node.pr_id;
      const cursor = typeof(prId) !== 'undefined' ? 'none': 'none';
      const isFather = this.isEven(ahn);

      let rotation = isFather ? angle : angle / 2;
      if( isFather) angle = angle / 2
      rotation = rotation * -1;

      if( level > 1 ){
        rotation = isFather ? currentFocusRotation: currentFocusRotation + angle;
      }

      currentFocusRotation = rotation;

      let innerRadius = undefined;
      let outerRadius = undefined;

      innerRadius = this.radiusHash[level].innerRadius
      outerRadius = this.radiusHash[level].outerRadius

      const midRadiusOfInnerAndOutterRing = (outerRadius - innerRadius)/2;

      let distanceFromCenter = outerRadius;

      let dateAliveText = buildDateAliveText({
        dob_c: parentNode.node.dob_c,
        dod_c: parentNode.node.dod_c,
        dob_y: parentNode.node.dob_y,
        dod_y: parentNode.node.dod_y,
        l: parentNode.node.l});

      const hasDate = this.hasDate({node: parentNode.node, level, ahn});

      if(hasDate && isRtl){
        const fixDateSymbols = (dateStr)=>{
          return ")" + dateStr.slice(1, -1) + "("}
        dateAliveText = fixDateSymbols(dateAliveText);
      }

      const adjustRowYPos = ({levelRowHeight, shiftRowsVertBy}) => {
        for (const level in levelRowHeight) {
          levelRowHeight[level] = levelRowHeight[level].map(yPos => yPos + shiftRowsVertBy);
        }
        return levelRowHeight;
      }

      let levelRowHeight = {
        5: [.5, -2.5, -5.5],
        6: [0, -2.25, -4.5],
        7: [ 0, -1.5],
        8: [-0.2],
      }

      let shiftRowsVertBy = 0;
      let dateShift = hasDate ? 1.5: 0;

      if(currentFocusRotation >= 270 ){ // Right side of fanchart
        levelRowHeight = Object.fromEntries(
          Object.entries(levelRowHeight).map(([level, array]) => [level, array.reverse()])
        );
        dateShift *= -1;
        shiftRowsVertBy = 4 + dateShift;
        levelRowHeight = adjustRowYPos({levelRowHeight, shiftRowsVertBy});
      } else {
        dateShift *= 1;
        shiftRowsVertBy = -1.3 + dateShift;
        levelRowHeight = adjustRowYPos({levelRowHeight, shiftRowsVertBy});
      }

      let straightPathNameObj = {1:{},2:{},3:{}};
      let halfAngle = (angle / 2);
      straightPathNameObj[1]['halfAngle'] = halfAngle + (level > 4 && levelRowHeight[level] ? levelRowHeight[level][0]: 0);
      straightPathNameObj[2]['halfAngle'] = halfAngle + (level > 4 && levelRowHeight[level] ? levelRowHeight[level][1]: 0);
      straightPathNameObj[3]['halfAngle'] = halfAngle + (level > 4 && levelRowHeight[level] ? levelRowHeight[level][2]: 0);


      let ahnRotation = -1 * (this.rotationHash[ahn].rotation);

      ahnRotation += this.levelHash[level]['leftArcAnglePadding'];

      straightPathNameObj[1]['outterTextRotation'] = rotation + straightPathNameObj[1]['halfAngle']
      straightPathNameObj[2]['outterTextRotation'] = rotation + straightPathNameObj[2]['halfAngle']
      straightPathNameObj[3]['outterTextRotation'] = rotation + straightPathNameObj[3]['halfAngle']

      let outterTextRotation = rotation + halfAngle;

      const changePlusToAddSomeone = (lastGhostParent && ahn.toString() === this.state.highlightGhost)
      let leftPaddingForTextInStraightTextPath = lastGhostParent && !changePlusToAddSomeone? 55.1: 10;
      if( changePlusToAddSomeone) leftPaddingForTextInStraightTextPath += 8;

      let sideOfCircle;
      if(outterTextRotation <= 270 ) sideOfCircle = 'left'
      else sideOfCircle = 'right'


      let fill;
      let textName = undefined;
      let stroke;
      let strokeWidth;

      if( parentNode.node.nm === '' || parentNode.node.nm === '+'){
        // fill = '#FFFFFF';
        textName = '';
        if( parentNode.node.nm === '+') textName =  parentNode.node.nm;
      } else {
        // textName = `${parentNode.node.nm.substring(this.levelHash[level]['substring'], 0)}`;
        textName = parentNode.node.nm;
      }

      const maxCharsPerRow = this.levelHash[level]['substring']
      const textNameArr = this.getRowsForName({fullName: textName, maxCharsPerRow});
      const textNameArrLength = textNameArr.length;
      const oneRowsExist = textNameArrLength === 1;
      const twoRowsExist = textNameArrLength === 2;
      const threeRowsExist = textNameArrLength >= 3;

      // if( ahn === this.testAhn){

      //   console.log(`textNameArrLength: `, textNameArrLength);

      //   console.log(`threeRowsExist: `, threeRowsExist);

      //   console.log(`textNameArr: `, JSON.stringify(textNameArr, null, 2));

      // }

      if( level >= 4 ){

        if(sideOfCircle === 'left') {

          const leftSidelevelShiftUpDown = this.getLeftSideLevelShiftDown({oneRowsExist, twoRowsExist, threeRowsExist, hasDate, ahn, textNameArr, dateAliveText, level, lastGhostParent})

          outterTextRotation += 180;

          straightPathNameObj[1]['outterTextRotation']  += 180;
          straightPathNameObj[2]['outterTextRotation']  += 180;
          straightPathNameObj[3]['outterTextRotation']  += 180;

          distanceFromCenter -= leftPaddingForTextInStraightTextPath;

          straightPathNameObj[1]['halfAngle'] = straightPathNameObj[1]['halfAngle'] + ( lastGhostParent ? leftSidelevelShiftUpDown[level][0]: leftSidelevelShiftUpDown[level][1] );
          straightPathNameObj[2]['halfAngle'] = straightPathNameObj[2]['halfAngle'] + leftSidelevelShiftUpDown[level][2];
          straightPathNameObj[3]['halfAngle'] = straightPathNameObj[3]['halfAngle'] + leftSidelevelShiftUpDown[level][3];

        } else {  // Rightside of Circle

          distanceFromCenter = this.radiusHash[level-1].outerRadius + leftPaddingForTextInStraightTextPath;



          if( level === 6 ){
            straightPathNameObj[1]['halfAngle'] = straightPathNameObj[1]['halfAngle'] - .5;
            straightPathNameObj[2]['halfAngle'] = straightPathNameObj[2]['halfAngle'] - .5;
            straightPathNameObj[3]['halfAngle'] = straightPathNameObj[3]['halfAngle'] - .5;
          }
          if( level === 7 ){
            straightPathNameObj[1]['halfAngle'] = straightPathNameObj[1]['halfAngle'] - 3.45;
            straightPathNameObj[2]['halfAngle'] = straightPathNameObj[2]['halfAngle'] - 3.45;
            straightPathNameObj[3]['halfAngle'] = straightPathNameObj[3]['halfAngle'] - 3.45;
          }

          if( level === 8 ){
            straightPathNameObj[1]['halfAngle'] = straightPathNameObj[1]['halfAngle'] - 4.45;
            straightPathNameObj[2]['halfAngle'] = straightPathNameObj[2]['halfAngle'] - 4.45;
            straightPathNameObj[3]['halfAngle'] = straightPathNameObj[3]['halfAngle'] - 4.45;
          }


          const rightSidelevelShiftUpDown = this.getRightSideLevelShiftDown({oneRowsExist, twoRowsExist, threeRowsExist, hasDate, ahn, textNameArr, dateAliveText, level, lastGhostParent})

          straightPathNameObj[1]['halfAngle'] = straightPathNameObj[1]['halfAngle'] + ( lastGhostParent ? rightSidelevelShiftUpDown[level][0]: rightSidelevelShiftUpDown[level][1] );
          straightPathNameObj[2]['halfAngle'] = straightPathNameObj[2]['halfAngle'] + rightSidelevelShiftUpDown[level][2];
          straightPathNameObj[3]['halfAngle'] = straightPathNameObj[3]['halfAngle'] + rightSidelevelShiftUpDown[level][3];



        }

      }

      straightPathNameObj[1]['sideHorizShift'] = rotation + straightPathNameObj[1]['halfAngle']
      straightPathNameObj[2]['sideHorizShift'] = rotation + straightPathNameObj[2]['halfAngle']
      straightPathNameObj[3]['sideHorizShift'] = rotation + straightPathNameObj[3]['halfAngle']

      let sideHorizShift = rotation + halfAngle;

      if( level <= 4 ){
          outterTextRotation += 91;
          distanceFromCenter -= 36;
      }

      straightPathNameObj[1]['lineX'] = this.centerX + distanceFromCenter * Math.cos((straightPathNameObj[1]['sideHorizShift'] * Math.PI) / 180);
      straightPathNameObj[2]['lineX'] = this.centerX + distanceFromCenter * Math.cos((straightPathNameObj[2]['sideHorizShift'] * Math.PI) / 180);
      straightPathNameObj[3]['lineX'] = this.centerX + distanceFromCenter * Math.cos((straightPathNameObj[3]['sideHorizShift'] * Math.PI) / 180);

      straightPathNameObj[1]['lineY'] = this.centerY + distanceFromCenter * Math.sin((straightPathNameObj[1]['sideHorizShift'] * Math.PI) / 180);
      straightPathNameObj[2]['lineY'] = this.centerY + distanceFromCenter * Math.sin((straightPathNameObj[2]['sideHorizShift'] * Math.PI) / 180);
      straightPathNameObj[3]['lineY'] = this.centerY + distanceFromCenter * Math.sin((straightPathNameObj[3]['sideHorizShift'] * Math.PI) / 180);

      const ahnColor = this.getAncestorParentsColor(ahn, this.ahnObj);
      const highlightProfile = ahn === this.state.highlight;
      const highlightOtherAhn = ahn === this.state.highlightOtherAhn;
      const highlightGhostProfile = ahn.toString() === this.state.highlightGhost;
      const highlightFrozen = ahn === this.state.highlightFrozen;
      const realParents = parentNode.node.nm !== '' && parentNode.node.nm !== '+';
      const whiteArcLayer = 1;
      const arcBarLayer = whiteArcLayer + 1;  // 2
      const dragOverLayer = whiteArcLayer + 2;  // 3
      const highlightLayer = whiteArcLayer + 3;  // 4
      const veryLastTopLayer = whiteArcLayer + 4;  // 5

/*
      if(ahn === 6){
        console.clear()
        console.log(`ahn: `, ahn);
        console.log(`this.state.highlightGhost: `, this.state.highlightGhost);
        console.log(`typeof()this.state.highlightGhost: `, typeof(this.state.highlightGhost));
        console.log(`typeof()ahn: `, typeof(ahn));
        console.log(`highlightGhostProfile: `, highlightGhostProfile);
      }
 */

      switch(layer.toString()) {

        case `${whiteArcLayer}`:
          fill='white'

        break;

        case `${arcBarLayer}`:
          if(realParents ){
            stroke = 'transparent';
            strokeWidth = 0;
            fill=ahnColor
          }

        break;

        case `${highlightLayer}`:
          if( highlightProfile || highlightOtherAhn || highlightFrozen ||
            (lastGhostParent && level === 2)){
            stroke = ahnColor;
            strokeWidth = 1;
            fill=ahnColor
          } else if( highlightGhostProfile ){
            stroke = ahnColor;
            strokeWidth = 1;
            // fill= (gender === 'm' ? maleDefaultColor: femaleDefaultColor)
            fill= (gender === 'm' ? '#D9EDFF': '#FFD9D9')
          } else {
            stroke = ahnColor;
            strokeWidth = 1;
            // fill='white'
          }
        break;

        default:
          stroke = 'lightgray';
          strokeWidth = 1;
      }

      const thicknessOfColoredArcBar = 5;

      // const innerRadius = (layer === arcBarLayer && realParents) ? outerRadius - thicknessOfColoredArcBar: innerRadius;

      // const edgeObj = this.getArcEdgeCoordinates({sideOfCircle, x: this.centerX, y: this.centerY, outerRadius, innerRadius, angle, rotation})

      // angle = angle + ( highlightProfile ?  2: 0)
      // rotation = rotation + ( highlightProfile ? -2: 0)
      // fill = ( highlightProfile ? 'red': fill)

      let ahnObj = {
        isFocus: false,
        fromWhere: 'Arc',
        lastGhostParent: parentNode.node.lastGhostParent,
        parentNode,
        gender: this.isOddAhn(parentNode.node.ahn) ? 'f': 'm',
        level,
        outterTextRotation,
        distanceFromCenter,
        sideOfCircle,
        sideHorizShift,
      }

      const arc = (
      <>

        {

          layer !== veryLastTopLayer

              ?

                layer === dragOverLayer ?


                          ahn === this.state.dragOverHighlight

                            ?

                          <Arc
                            key={`arc-${index}`}
                            x={this.centerX}
                            y={this.centerY}
                            innerRadius={innerRadius - 15}
                            outerRadius={outerRadius + 15}
                            angle={angle + 5}
                            rotation={rotation - 2.5}
                            fill={'#6BADDE'}
                            opacity={.2}
                            cursor={cursor}
                            stroke={stroke}
                            strokeWidth={strokeWidth}

                          />

                            :

                          null

                    :


                    <Arc
                      key={`arc-${index}`}
                      x={this.centerX}
                      y={this.centerY}
                      innerRadius={layer === arcBarLayer && realParents ? outerRadius - thicknessOfColoredArcBar: innerRadius}
                      outerRadius={outerRadius}
                      angle={angle - 0}
                      rotation={rotation - 0}
                      fill={fill}
                      cursor={cursor}
                      stroke={stroke}
                      strokeWidth={strokeWidth}
                      /*
                        onTouchStart={(e)=>{
                          // e.stopPropagation();
                          window.alert();
                        }}
                       */
                      onTouchStart={this.clickArc.bind(this, ahnObj)}
                      onClick={this.clickArc.bind(this, ahnObj)}
                      onMouseenter={()=>{
                        let childAlsoGhost = false;
                        childAlsoGhost = parentNode.node.childNode && parentNode.node.childNode.lastGhostParent;
                        if(childAlsoGhost){
                          this.props.cursorBecomesMove();
                          return;
                        }
                        this.mouseEnterChangeHighlight(ahnObj);
                      }}

                      onMouseleave={()=>{
                        if( lastGhostParent ){this.setHighlightGhost(0);}
                        this.props.cursorBecomesMove();
                      }}
                    />

            :

                null

        }



        {

          (layer === veryLastTopLayer && highlightProfile && realParents) || (layer === veryLastTopLayer && highlightFrozen && realParents)

              ?

                this.getFocusTabIcon({ahnColor, level, index, straightPathNameObj, dateAliveText, textName, fontFamily, cursor, prId, layer, parentNode, sideOfCircle, distanceFromCenter, sideHorizShift, outterTextRotation})
            :

                null

        }


        {

          (layer === veryLastTopLayer && highlightOtherAhn )

              ?

                this.getCycleTabIcon({ahnColor, level, index, straightPathNameObj, dateAliveText, textName, fontFamily, cursor, prId, layer, parentNode, sideOfCircle, distanceFromCenter, sideHorizShift, outterTextRotation})
            :

            null
/*

                ()=>{

                     console.log(`%c boo`, [
                       'color: white',
                       'background: purple',
                       'font-size: 14px',
                       'border: 5px solid red',
                       'padding: 10px',
                       ].join(';'));

                }
 */

        }

        {

          layer === veryLastTopLayer

              ?

              <>

                  {

                    level > 4

                        ?

                      this.getStraightText({
                        level,
                        index,
                        straightPathNameObj,
                        dateAliveText,
                        textName,
                        fontFamily,
                        cursor,
                        prId,
                        layer,
                        parentNode,
                        sideOfCircle,
                        angle,
                        ahn,
                        outterTextRotation,
                        distanceFromCenter,
                        sideHorizShift,

                      })

                      :

                      this.getArcText({layer,
                        parentNode,
                        ahn,
                        level,
                        ahnRotation,
                        innerRadius,
                        midRadiusOfInnerAndOutterRing,
                        prId,
                        dateAliveText, hasDate, sideOfCircle,
                        outterTextRotation,
                        distanceFromCenter,
                        sideHorizShift,
                      })

                  }
              </>

            :

            null

        }

      </>);

      if (parentNode.parents.length === 2) {

        const parentArcs = this.drawArcs({layer, level, angle, parents: parentNode.parents, currentFocusNodeObj: parentNode.node, currentFocusRotation});

        return [arc, ...parentArcs];

      } else {

        const addFather = parentNode.node.nm !== '' && !parentNode.node.lastGhostParent && !this.state.isPrint   ? '+': '';
        const addMother = parentNode.node.nm !== ''  && !parentNode.node.lastGhostParent && !this.state.isPrint   ? '+': '';

        const ahnArr = this.getAncestorParentsahns(parentNode.node.ahn, this.ahnObj);
        let parents = [{
                node: {
                  ahn: ahnArr[0],
                  nm: addFather,
                  lastGhostParent: true,
                  g: 'm',
                  childNode: parentNode.node
                  },
                parents:[],
              },{
                node: {
                  ahn: ahnArr[1],
                  nm: addMother,
                  lastGhostParent: true,
                  g: 'f',
                  childNode: parentNode.node
                  },
                parents:[],
              },
          ];;

        if ( parentNode.parents.length === 1 ){
          if( parentNode.parents[0].node.g === 'm' || parentNode.parents[0].node.g === 'u'  || !parentNode.parents[0].node.g ){
            parents.shift();
            parents.unshift(parentNode.parents[0]);
          } else {
            parents.pop();
            parents.push(parentNode.parents[0]);
          }
        }

        if( level < 8 ){

          const parentArcs = this.drawArcs({
            layer,
            level,
            angle,
            parents,
            currentFocusNodeObj: parentNode.node,
            currentFocusRotation
          });

          return [arc, ...parentArcs];

        }


        return arc;

      }
    }).filter(Boolean);

    return arcs
  }

  drawArcLayers({howmany, justLayer, uptoLayer}){

    if( typeof(uptoLayer) !== 'undefined' ){

      let arcLayers = []

      for (let layer = 1; layer <= uptoLayer; layer++) {
        const arcLayer = this.drawArcs({
                  level: 1,
                  layer: layer,
                  angle: this.halfCircle + this.tilt,
                  currentFocusRotation: this.halfCircle - this.tilt/2,
                  parents: this.props.fanChartData.parents,
                  currentFocusNodeObj: this.props.fanChartData.node
              })
        arcLayers.push(arcLayer);
      }

      return arcLayers;
    }

    if( typeof(justLayer) !== 'undefined' ){

      const arcLayer = this.drawArcs({
                level: 1,
                layer: justLayer,
                angle: this.halfCircle + this.tilt,
                currentFocusRotation: this.halfCircle - this.tilt/2,
                parents: this.props.fanChartData.parents,
                currentFocusNodeObj: this.props.fanChartData.node
            })

      return [arcLayer];
    }

    let arcLayers = []

    for (let layer = 1; layer <= howmany; layer++) {
      const arcLayer = this.drawArcs({
                level: 1,
                layer: layer,
                angle: this.halfCircle + this.tilt,
                currentFocusRotation: this.halfCircle - this.tilt/2,
                parents: this.props.fanChartData.parents,
                currentFocusNodeObj: this.props.fanChartData.node
            })
      arcLayers.push(arcLayer);
    }

    return arcLayers;
  }

  getFocusName(){

    let fullName = this.props.fanChartData.node.nm;

    const fullNameArray = this.getRowsForName({fullName, maxCharsPerRow: 16});

    // console.log(`fullNameArray: `, JSON.stringify(fullNameArray, null, 2));

    const lengthRow1 = getWidthKonvaText({
        str: fullNameArray[0],
        fontSize: 14,
        fontFamily,
        fontStyle: fullNameFontStyle,
        lineHeight: fullNameLineHeight
      });

    const lengthRow2 = getWidthKonvaText({
        str: fullNameArray[1],
        fontSize: 14,
        fontFamily,
        fontStyle: fullNameFontStyle,
        lineHeight: fullNameLineHeight
      });

    const lengthRow3 = getWidthKonvaText({
        str: fullNameArray[2],
        fontSize: 14,
        fontFamily,
        fontStyle: fullNameFontStyle,
        lineHeight: fullNameLineHeight
      });

    const xStartRow1 = this.centerX - lengthRow1/2
    const xStartRow2 = this.centerX - lengthRow2/2
    const xStartRow3 = this.centerX - lengthRow3/2

    let yStartRow1 = this.centerY - 20;
    let yStartRow2 = this.centerY;
    let yStartRow3 = this.centerY + 20;

    if( fullNameArray.length === 1 ){
      yStartRow1 += 12.5;
      yStartRow2 += 12.5;
      yStartRow3 += 12.5;
    }

    if( fullNameArray.length === 2 ){
      yStartRow1 -= 0;
      yStartRow2 -= 0;
      yStartRow3 -= 0;
    }

    if( fullNameArray.length === 3 ){
      yStartRow1 -= 15;
      yStartRow2 -= 15;
      yStartRow3 -= 15;
    }

    return <Fragment>
              <Text
                key={Math.random()}
                x={xStartRow1}
                y={yStartRow1}
                text={`${fullNameArray[0]}`}
                fontSize={14}
                fontStyle="bold"
                fill={'black'}
                align="center"
                verticalAlign="middle"
                onMouseenter={()=>{
                    this.setHighlightFocus({how: true});
                    this.setHighlight(0); this.setDragOverHighlight(0);
                    this.props.cursorBecomesPointer();
                }}
                onMouseleave={()=>{
                  this.props.cursorBecomesMove();
                  this.setHighlightFocus({how: false});
                }}

                onTouchStart={this.clickArc.bind(this, {
                    isFocus: true,
                    fromWhere: 'Circle',
                    lastGhostParent: undefined,
                    parentNode:this.props.fanChartData,
                  })}

                onClick={this.clickArc.bind(this, {
                    isFocus: true,
                    fromWhere: 'Circle',
                    lastGhostParent: undefined,
                    parentNode:this.props.fanChartData,
                  })}
              />

              {

                    typeof(fullNameArray[1]) !== 'undefined'

                    ?

                        <Fragment>
                          <Text
                            key={Math.random()}
                            x={xStartRow2}
                            y={yStartRow2}
                            text={`${fullNameArray[1]}`}
                            fontSize={14}
                            fontStyle="bold"
                            fill={'black'}
                            align="center"
                            verticalAlign="middle"
                            onMouseenter={()=>{
                                this.setHighlightFocus({how: true});
                                this.setHighlight(0); this.setDragOverHighlight(0);
                                this.props.cursorBecomesPointer();
                            }}
                            onMouseleave={()=>{
                              this.props.cursorBecomesMove();
                              this.setHighlightFocus({how: false});
                            }}

                            onTouchStart={this.clickArc.bind(this, {
                                          isFocus: true,
                                          fromWhere: 'Circle',
                                          lastGhostParent: undefined,
                                          parentNode:this.props.fanChartData,
                                        })}
                            onClick={this.clickArc.bind(this, {
                                isFocus: true,
                                fromWhere: 'Circle',
                                lastGhostParent: undefined,
                                parentNode:this.props.fanChartData,
                              })}
                          />
                        </Fragment>

                    :

                    null

              }
              {

                    typeof(fullNameArray[2]) !== 'undefined'

                    ?

                        <Fragment>
                          <Text
                            key={Math.random()}
                            x={xStartRow3}
                            y={yStartRow3}
                            text={`${fullNameArray[2]}`}
                            fontSize={14}
                            fontStyle="bold"
                            fill={'black'}
                            align="center"
                            verticalAlign="middle"
                            onMouseenter={()=>{
                                this.setHighlightFocus({how: true});
                                this.setHighlight(0); this.setDragOverHighlight(0);
                                this.props.cursorBecomesPointer();
                            }}
                            onMouseleave={()=>{
                              this.props.cursorBecomesMove();
                              this.setHighlightFocus({how: false});
                            }}

                            onTouchStart={this.clickArc.bind(this, {
                                          isFocus: true,
                                          fromWhere: 'Circle',
                                          lastGhostParent: undefined,
                                          parentNode:this.props.fanChartData,
                                        })}
                            onClick={this.clickArc.bind(this, {
                                isFocus: true,
                                fromWhere: 'Circle',
                                lastGhostParent: undefined,
                                parentNode:this.props.fanChartData,
                              })}
                          />
                        </Fragment>

                    :

                    null

              }
            </Fragment>
  }

  render() {

    if (!this.props.fanChartData ) return null;

    // console.count('render');

    return (

      <Fragment>

                <Fragment>

                    {
                          <Fragment>
                           {

                              !this.state.isPrint

                                    ?


                                <Circle
                                  x={this.centerX}
                                  y={this.centerY}
                                  radius={this.radiusHash[this.maxLevels]['outerRadius']}
                                  fill={'white'}
                                />


                                :

                              null


                            }
                          </Fragment>

                    }

                    {
                          <Fragment>
                           {

                              !this.state.isPrint

                                    ?

                                 <Arc
                                  key={`bottomArc`}
                                  x={this.centerX}
                                  y={this.centerY}
                                  innerRadius={79.75}
                                  outerRadius={this.radiusHash[this.maxLevels]['outerRadius']}
                                  angle={135}
                                  rotation={22.5}
                                  fill={ !this.state.isPrint ? `${this.props.stageBackgroundColor}`: undefined}
                                  // fill={`#EEF0DD`}
                                  // fill={`blue`}
                                  onMouseenter={()=>{
                                    this.setHighlight(0); this.setDragOverHighlight(0);
                                  }}
                                />

                                :

                              null


                            }

                          </Fragment>
                    }


                    {
                          <Circle
                            stroke={'lightgray'}
                            x={this.centerX}
                            y={this.centerY}
                            radius={79.75}
                            fill={`${ this.state.highlightFocus ? '#DBDBDB': 'white'}`}
                            strokeWidth={1}
                            onMouseenter={()=>{
                                this.setHighlightFocus({how: true});
                                this.setHighlight(0);
                                this.setDragOverHighlight(1);
                                this.props.cursorBecomesPointer();

                                if( this.state.floaterActive ){

                                     console.log(`%c onMouseenterFloater`, [
                                       'color: white',
                                       'background: orange',
                                       'font-size: 14px',
                                       'border: 5px solid red',
                                       'padding: 10px',
                                       ].join(';'));

                                  this.setDragOverHighlight(1);
                                  // this.props.setDropOnNode(parentNode.node.n);
                                }


                            }}
                            onMouseleave={()=>{
                              this.props.cursorBecomesMove();
                              this.setHighlightFocus({how: false});
                            }}


                            onTouchStart={this.clickArc.bind(this, {
                                          isFocus: true,
                                          fromWhere: 'Circle',
                                          lastGhostParent: undefined,
                                          parentNode:this.props.fanChartData,
                                        })}

                            onClick={this.clickArc.bind(this, {
                                isFocus: true,
                                fromWhere: 'Circle',
                                lastGhostParent: undefined,
                                parentNode:this.props.fanChartData,
                              })}
                            />

                    }
                </Fragment>



          {
             this.drawArcLayers({howmany: 5, uptoLayer: undefined, justLayer: undefined})
          }


          {

              this.state.floaterActive && this.state.highlightFocus

              ?

              <Circle
                x={this.centerX}
                y={this.centerY}
                radius={90}
                fill={'#6BADDE'}
                // fill={'red'}
                opacity={.2}
              />

              :

              null
          }

          {
            this.getFocusName()
          }


      </Fragment>

    );
  }
}

export default FanChart;
